module.exports = __webpack_public_path__ + "mm.svg?361afba5b3ba3e57ecea4bd3a965cf7b";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mm.svg
// module id = 1321
// module chunks = 27